export function startWhirlpoolTransition(onComplete) {
  const canvas = document.createElement("canvas");
  canvas.style.cssText =
    "position:fixed;inset:0;z-index:99999;pointer-events:all;width:100%;height:100%";
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  document.body.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  const cx = canvas.width / 2;
  const cy = canvas.height / 2;
  const maxR = Math.hypot(cx, cy);
  const DURATION = 1500;
  let start = null;

  function frame(now) {
    if (!start) start = now;
    const t = Math.min((now - start) / DURATION, 1);

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Dark water overlay deepening over time
    ctx.fillStyle = `rgba(2, 10, 24, ${Math.min(t * 1.8, 0.94)})`;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Spinning vortex rings collapsing toward center
    const spin = t * Math.PI * 10;
    const ringCount = 18;
    for (let i = 0; i < ringCount; i++) {
      const fi = i / ringCount;
      const r = maxR * fi * Math.max(1 - t * 0.96, 0.04);
      if (r < 2) continue;

      const fadeOut = Math.max(1 - Math.max(t - 0.65, 0) / 0.35, 0);
      const alpha = (1 - fi) * 0.55 * Math.min(t * 5, 1) * fadeOut;
      ctx.strokeStyle = `hsla(${198 + fi * 28}, 72%, ${50 + fi * 22}%, ${alpha})`;
      ctx.lineWidth = 1 + (1 - fi) * 3.5;

      const startAngle = spin + fi * Math.PI * 0.9;
      ctx.beginPath();
      ctx.arc(cx, cy, r, startAngle, startAngle + Math.PI * 1.5);
      ctx.stroke();
    }

    // Three spiral arms tightening inward
    for (let arm = 0; arm < 3; arm++) {
      const armBase = spin + (arm / 3) * Math.PI * 2;
      const armFade = Math.max(1 - Math.max(t - 0.55, 0) / 0.45, 0);
      ctx.strokeStyle = `rgba(60, 188, 255, ${0.4 * Math.min(t * 3, 1) * armFade})`;
      ctx.lineWidth = 1.5;
      ctx.beginPath();
      let first = true;
      const outerR = maxR * Math.max(1 - t * 0.92, 0.08);
      for (let r = outerR; r > 5; r -= 5) {
        const angle = armBase + ((maxR - r) / maxR) * Math.PI * 5;
        const px = cx + Math.cos(angle) * r;
        const py = cy + Math.sin(angle) * r;
        if (first) {
          ctx.moveTo(px, py);
          first = false;
        } else {
          ctx.lineTo(px, py);
        }
      }
      ctx.stroke();
    }

    // Center drain void — expands and deepens
    const holeR = t * t * maxR * 0.4;
    if (holeR > 1) {
      const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, holeR);
      grad.addColorStop(0, "rgba(0, 0, 0, 1)");
      grad.addColorStop(0.35, "rgba(0, 6, 18, 0.95)");
      grad.addColorStop(1, "rgba(0, 6, 18, 0)");
      ctx.fillStyle = grad;
      ctx.beginPath();
      ctx.arc(cx, cy, holeR, 0, Math.PI * 2);
      ctx.fill();
    }

    // Initial ripple burst — emanates from center at start
    if (t < 0.35) {
      const rippleT = t / 0.35;
      for (let rp = 0; rp < 4; rp++) {
        const rt = Math.max(0, rippleT - rp * 0.08);
        if (rt <= 0) continue;
        const rippleR = rt * maxR * 0.55;
        ctx.strokeStyle = `rgba(100, 220, 255, ${(1 - rt) * 0.45})`;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(cx, cy, rippleR, 0, Math.PI * 2);
        ctx.stroke();
      }
    }

    // Valknut in the center drain as it forms
    if (t > 0.4) {
      const runeAlpha =
        Math.min((t - 0.4) / 0.3, 1) * Math.max(1 - (t - 0.85) / 0.15, 0);
      if (runeAlpha > 0) {
        const valknutPath = new Path2D(
          "M24.96 25.664l2.752 5.056h-21.504l11.52-20.864 3.904-7.168 10.752 19.712h-19.712v1.28h21.888l-12.928-23.68-5.056 9.28-12.544 22.72h25.856l-3.776-6.912-1.152 0.576zM18.88 11.84l-1.152 0.64 4.672 8.448 1.152-0.64-4.672-8.448zM7.488 22.4h-5.312l10.752-19.712 2.432 4.48 1.152-0.64-3.584-6.528-12.928 23.68h7.488v-1.28z",
        );
        const size = 20 + t * 30;
        const scale = size / 35;
        ctx.save();
        ctx.globalAlpha = runeAlpha;
        ctx.translate(cx - (35 * scale) / 2, cy - (32 * scale) / 2);
        ctx.scale(scale, scale);
        ctx.fillStyle = "#ffab00";
        ctx.shadowColor = "#ffab00";
        ctx.shadowBlur = 20 / scale;
        ctx.fill(valknutPath);
        ctx.shadowBlur = 0;
        ctx.restore();
      }
    }

    if (t < 1) {
      requestAnimationFrame(frame);
    } else {
      onComplete();
      setTimeout(() => canvas.remove(), 600);
    }
  }

  requestAnimationFrame(frame);
}
